import React from 'react';
import { Spinner } from 'reactstrap';
import { connect } from 'react-redux';

function LoaderComponent(props) {
  if (!props.loading) return null;

    const { align, verticalAlign } = props;

    return (
      <div className={'loader spinner w-100 h-100 ' + align + ' ' + verticalAlign}>
        <Spinner color='danger' />
      </div>
    );
}


LoaderComponent.defaultProps = {
    loading: false,
    align: '',
    verticalAlign: '',
};

const mapStateToProps = state => ({
  loading: state.loading.pendingRequests
});

const Loader = connect(mapStateToProps)(LoaderComponent);

export { Loader, LoaderComponent };


